<template>
  <CCol>
    <CRow class="mx-n4">
      <PostingDetailsWidget
        label="Furnished"
        icon="faCouch"
        :value="property.furnished"
      />
      <PostingDetailsWidget
        label="Dog Policy"
        icon="faDog"
        :value="property.dog_policy"
      />
      <PostingDetailsWidget
        label="Cat Policy"
        icon="faCat"
        :value="property.cat_policy"
      />
      <PostingDetailsWidget
        label="Parking"
        icon="faCar"
        :value="property.parking"
      />
      <PostingDetailsWidget
        label="EV Charging"
        icon="faChargingStation"
        :value="property.ev_charging"
      />
      <PostingDetailsWidget
        label="Air Conditioning"
        icon="faSnowBlowing"
        :value="property.air_conditioning"
      />
      <PostingDetailsWidget
        label="Laundry"
        icon="faWashingMachine"
        :value="property.laundry"
      />
      <PostingDetailsWidget
        label="Smoking Policy"
        icon="faSmoking"
        :value="property.smoking_policy"
      />
      <PostingDetailsWidget
        label="Wheelchair Accessible"
        icon="faWheelchairMove"
        :value="property.wheelchair_access"
      />
    </CRow>
  </CCol>
</template>

<script>
import PostingDetailsWidget from './PostingDetailsWidget'

export default {
  name: 'PostingDetailAmenities',
  components: {
    PostingDetailsWidget
  },
  props: {
    property: {
      default: null,
      type: Object
    }
  }
}
</script>
